import React from 'react';

// Logo Lockup Component
// Renders the official Casanova brand PNG lockups (Forest Green + Brick Orange)
// Text is the header LogoWordmark (kept separately).
// The PNG files ship with a thin white border; we crop it with scale + overflow-hidden.

const LOGO_SRC = {
  // Forest Green ground, white lettering
  green: 'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/0na616ts_FullLockup-Green.png',
  // Brick Orange ground, white lettering
  orange: 'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/xeejzpdg_FullLockup-Orange.png',
};

export const LogoLockup = ({
  variant = 'green', // green | orange (legacy: forest → green, brick → orange, noir → green, parchment → orange)
  size = 'md',
  className = '',
}) => {
  // Map legacy variants to the two real PNG logos
  const mapped =
    variant === 'brick' || variant === 'parchment' || variant === 'orange'
      ? 'orange'
      : 'green';

  const sizes = {
    sm: 'w-24 h-24',
    md: 'w-36 h-36',
    lg: 'w-52 h-52',
    xl: 'w-64 h-64',
  };
  const box = sizes[size] || sizes.md;

  return (
    <div
      className={`relative overflow-hidden inline-block ${box} ${className}`}
      data-testid="logo-lockup"
      style={{
        backgroundImage: `url(${LOGO_SRC[mapped]})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
      }}
      role="img"
      aria-label="Casanova Salon Barbier"
    />
  );
};

// Simple wordmark version (no box) - for nav and small applications
export const LogoWordmark = ({
  color = 'dark', // dark (noir) or light (parchment)
  size = 'md',
  className = '',
}) => {
  const textColor = color === 'light' ? '#F5F0E8' : '#1A1A18';
  const mutedColor = '#8A8780'; // Warm Grey per brand book

  const sizes = {
    sm: { main: 'text-lg', sub: 'text-[8px]' },
    md: { main: 'text-xl', sub: 'text-[9px]' },
    lg: { main: 'text-2xl', sub: 'text-[10px]' },
  };

  const s = sizes[size] || sizes.md;

  return (
    <div className={`text-left ${className}`}>
      <span
        className={`font-display ${s.main} tracking-[0.1em]`}
        style={{ color: textColor }}
      >
        CASANOVA
      </span>
      <div
        className={`font-body font-extralight ${s.sub} tracking-[0.22em] uppercase`}
        style={{ color: mutedColor }}
      >
        SALON · BARBIER
      </div>
    </div>
  );
};

export default LogoLockup;
